import { Component, OnInit } from '@angular/core';
import 'rxjs/add/operator/filter';
import {IMyDpOptions} from 'mydatepicker';
import dayGridPlugin from '@fullcalendar/daygrid';
// import { MyservicesService } from './myservices';


@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
    calendarPlugins = [dayGridPlugin];
    myDatePickerOptions: IMyDpOptions = {
        // other options...
        dateFormat: 'dd/mm/yyyy',
        alignSelectorRight: true,
    };
    constructor() {}

    ngOnInit() {
    }
}
